/** @jsxImportSource @emotion/react */

import { FC, ReactNode } from "react";
import { css } from "@emotion/react";
import { SimpleListItem } from "@rmwc/list";
import Direction from "../../../../commons/Direction";
import { Link } from "react-router-dom";
import List from "../List";
import useConfigs from "../../../ConfigContext/use-configs";

type ListItemProps = {
  currentSelected?: string;
  path?: string;
  onClick?: (clickedItem: string) => void;
  dir?: Direction;
  text?: ReactNode;
  activated?: undefined | boolean;
  disabled?: undefined | boolean;
  meta?: ReactNode | string /**Meta content for the ListItem instead of an icon.*/;
  metaIcon?: any;
  subText?: ReactNode;
  icon?: any;
  twoLine?: boolean;
  level?: number | undefined;
  className?: string;
};

const ListItem: FC<ListItemProps> = (props) => {
  let configs = useConfigs();
  const {
    onClick,
    activated = false,
    disabled = false,
    meta,
    metaIcon,
    text,
    subText,
    icon,
    path,
    currentSelected,
    twoLine = false,
    level = 0,
    dir = configs.direction,
    className,
  } = props;

  const handleClick = () => {
    onClick(path);
  };

  const isSelected = currentSelected === path;

  const styles = css`
    padding-right: ${level !== undefined ? (level + 1) * 15 : 0}px !important;
    padding-left: 5px !important;
    .mdc-list-item__graphic {
      margin-left: 20px !important;
    }
  `;

  const renderItem = () => {
    return (
      <SimpleListItem
        onClick={handleClick}
        activated={activated}
        selected={isSelected}
        graphic={icon}
        text={text}
        secondaryText={subText}
        metaIcon={metaIcon}
        meta={!metaIcon && meta}
        disabled={disabled}
        css={styles}
        dir={dir}
        className={className}
      />
    );
  };

  return (
    <List twoLine={twoLine} dir={dir} className={className}>
      {path ? <Link to={path}>{renderItem()}</Link> : renderItem()}
    </List>
  );
};

export default ListItem;
